import {Text} from '@mantine/core';
import {DataTableColumn} from 'mantine-datatable';
import {I18n} from '@aws-amplify/core';

import {formatTimestamp} from '../../../utils/TableTimestamps';
import {Product} from '../types';

// Every column is sortable (MODULE_COMPLIANCE_CHECKLIST §3a). The accessor is
// what useTableSort sorts by; render only controls how the cell looks.
export const useProductsTableColumns = (onRecordClick: (record: Product) => void): DataTableColumn<Product>[] => [
    {
        accessor: 'productTitle',
        title: I18n.get('Product Title'),
        sortable: true,
        render: (item) => (
            <Text
                c="blue"
                style={{cursor: 'pointer'}}
                onClick={() => onRecordClick(item)}
            >
                {item.productTitle}
            </Text>
        ),
    },
    {
        accessor: 'productId',
        title: I18n.get('Product ID'),
        sortable: true,
    },
    {
        accessor: 'productCode',
        title: I18n.get('Product Code'),
        sortable: true,
    },
    {
        accessor: 'created',
        title: I18n.get('Created'),
        sortable: true,
        render: (item) => formatTimestamp(item.created),
    },
];
